import React from 'react';
import PropTypes from 'prop-types';

import Lift5 from "./lifts/Lift5";
import Lift1R from "./lifts/Lift1R";
import LiftNone from "./lifts/LiftNone";
import Lift6 from "./lifts/Lift6";
import Lift17 from "./lifts/Lift17";
import Lift12 from "./lifts/Lift12";
import Lift16 from "./lifts/Lift16";
import Lift11 from "./lifts/Lift11";
import Lift2 from "./lifts/Lift2";
import Lift2R from "./lifts/Lift2R";
import Lift22 from "./lifts/Lift22";
import Lift13 from "./lifts/Lift13";
import Lift15 from "./lifts/Lift15";
import Lift14 from "./lifts/Lift14";
import Lift8 from "./lifts/Lift8";
import Lift7 from "./lifts/Lift7";
import Lift3 from "./lifts/Lift3";
import { AppContext } from "../App";
import Lift7R from "./lifts/Lift7R";
import LiftM from "./lifts/LiftM";
import Lift9 from "./lifts/Lift9";

const LocalLiftsData = [
	{ id: 'Lift5', component: Lift5 },
	{ id: 'Lift1', component: Lift1R },
	//{ id: 'LiftNone', component: LiftNone },
	{ id: 'Lift6', component: Lift6 },
	{ id: 'Lift17', component: Lift17 },
	{ id: 'Lift12', component: Lift12 },
	{ id: 'Lift16', component: Lift16 },
	{ id: 'Lift11', component: Lift11 },
	{ id: 'Lift2', component: Lift2 },
	{ id: 'Lift2R', component: Lift2R },
	{ id: 'Lift22', component: Lift22 },
	{ id: 'Lift13', component: Lift13 },
	{ id: 'Lift15', component: Lift15 },
	{ id: 'Lift14', component: Lift14 },
	{ id: 'Lift8', component: Lift8 },
	{ id: 'Lift9', component: Lift9},
	{ id: 'Lift7', component: Lift7 },
	{ id: 'Lift3', component: Lift3 },
	{ id: 'Lift7R', component: Lift7R },
	{ id: 'LiftM', component: LiftM },
];

const Lifts = ({ activeLiftId }) => (
	<AppContext.Consumer>
		{({ liftsData, tracksState }) => (
			<>
				{LocalLiftsData.map((localLift, index) => {
					if (typeof liftsData[localLift.id] === 'undefined')
						return null;

					const LiftComponent = localLift.component;
					return <LiftComponent
						isOpen={liftsData[localLift.id].isOpen}
						state={tracksState}
						key={localLift.id}
						activeLiftId={activeLiftId}/>
				})}
			</>
		)}
	</AppContext.Consumer>
);

Lifts.propTypes = {
	activeLiftId: PropTypes.string
};

export default Lifts;
